// src/components/ui/ErrorDisplay.jsx
import React from 'react';

const ErrorDisplay = ({ title = "エラーが発生しました", message, children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="p-8 bg-red-50 text-center text-red-700 rounded-xl border border-red-200 max-w-md mx-auto shadow-lg">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">🚨</span>
        </div>
        <h2 className="font-bold text-xl mb-2">{title}</h2>
        <p className="text-red-600 mb-4">{message}</p>
        {children && (
          <div className="space-y-2">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorDisplay;